import type { IxcSweepsV1SweepTargetKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const SWEEP_TARGET_BASE_PATH = getResolvedPath('/sweep/target');

export const getSweepTargetPath: EntityPathBuilder<IxcSweepsV1SweepTargetKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return SWEEP_TARGET_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.sweepTargetId) {
        return undefined;
      }

      return getResolvedPath(`${SWEEP_TARGET_BASE_PATH}/$sweepTargetId`, context.keys);
    }
  }
};

export function getSweepTargetDetailPath(sweepTargetId: string | undefined) {
  if (!sweepTargetId) {
    return undefined;
  }

  return getSweepTargetPath({ kind: 'detail', keys: { sweepTargetId } });
}

